import {
  config as faConfig,
  dom as faDom,
  library,
} from '@fortawesome/fontawesome-svg-core';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import * as IconsRegular from '@fortawesome/free-regular-svg-icons';
import * as IconsBrand from '@fortawesome/free-brands-svg-icons';
import { Sitemap, WysiwygWidget } from '@plone/volto/components';
import itinerarySVG from 'iovisit-theme/icons/itinerary.svg';
import pointOfInterestSVG from 'iovisit-theme/icons/point-of-interest.svg';
import restaurantSVG from 'iovisit-theme/icons/restaurant.svg';
import accomodationSVG from 'iovisit-theme/icons/accomodation.svg';
import eventSVG from 'iovisit-theme/icons/event.svg';
import subsiteSVG from 'iovisit-theme/icons/subsite.svg';
import WhishlistPage from 'iovisit-theme/components/Views/WhishlistPage/WhishlistPage';
import Favicon from 'iovisit-theme/components/layout/Favicon/Favicon';
import HandleMenuFocus from 'iovisit-theme/components/HandleMenuFocus/HandleMenuFocus';

import {
  IoVisitConfig,
  IoVisitBlocks,
  IoVisitWidgets,
  IoVisitViews,
  IoVisitRoutes,
  RichTextConfig,
} from 'iovisit-theme/config';
import {
  searchFiltersStructures,
  searchResults,
  searchFiltersEvents,
  whishlist,
} from 'iovisit-theme/reducers';

//FontAwesome icons
faConfig.autoAddCss = false;
const iconList = Object.keys(Icons.fas).map((icon) => Icons[icon]);
const iconListRegular = Object.keys(IconsRegular.far).map(
  (icon) => IconsRegular[icon],
);
const iconListBrand = Object.keys(IconsBrand.fab).map(
  (icon) => IconsBrand[icon],
);
library.add(...iconList, ...iconListRegular, ...iconListBrand);

const applyConfig = (config) => {
  //config.settings.bbb_listingBlockFetchesFullobjects = true; //da togliere
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['it'];
  config.settings.defaultLanguage = 'it';
  config.settings.timezone = 'Europe/Rome';
  config.settings.verticalFormTabs = true;
  config.settings.showTags = false;
  config.settings.showSelfRegistration = false;
  config.settings.showWishlistWidget = true;
  config.settings.defaultPageSize = 24;
  config.settings['volto-editablefooter'] = {
    options: { socials: false, newsletterSubscribe: false },
  };

  // config draftJs
  config.settings.defaultBlockType = 'text';
  config.blocks.blocksConfig.table.restricted = false;
  config.blocks.blocksConfig.slateTable.restricted = true;
  config.widgets.widget.richtext = WysiwygWidget;

  config.settings.persistentReducers = [
    ...config.settings.persistentReducers,
    'whishlist',
  ];
  config.settings.contentIcons = {
    ...config.settings.contentIcons,
    Event: eventSVG,
    Itinerary: itinerarySVG,
    PointOfInterest: pointOfInterestSVG,
    Restaurant: restaurantSVG,
    Accomodation: accomodationSVG,
    Subsite: subsiteSVG,
  };

  config.settings.iovisit = IoVisitConfig;

  IoVisitRoutes(config);
  IoVisitWidgets(config);
  IoVisitViews(config);
  IoVisitBlocks(config);
  RichTextConfig(config);

  config.addonReducers = {
    ...config.addonReducers,
    searchFiltersStructures,
    searchResults,
    searchFiltersEvents,
    whishlist,
  };

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '*/wishlist',
      component: WhishlistPage,
    },
    {
      path: '/**/sitemap',
      component: Sitemap,
    },
  ];

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    '/wishlist',
  ];

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: () => <style type="text/css">{faDom.css()}</style>, //load fontawesom dom css
    },
    {
      match: '',
      component: Favicon,
    },
    {
      match: '',
      component: HandleMenuFocus,
    },
  ];

  config.settings['volto-gdpr-privacy'].defaultPanelConfig.text.it.description =
    "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. Per i cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Impostazioni'. Per saperne di più, su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/it/privacy-policy'>Cookie Policy</a>.";

  return config;
};

export default applyConfig;
